import { useFormik } from 'formik';
import { RedirectAreaParamsDataProps } from './props';
import { useEffect } from 'react';

export const useRedirectAreaData = ({ data }: RedirectAreaParamsDataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra', data?.extra || '');
    }, [data]);

    return {
        formik,
    };
};
